import * as React from "react";
const SvgFiRrHorseSaddle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-horse-saddle_svg__a)">
      <path
        fill="#062147"
        d="M22.812 6.768C20.788 5.866 19.44 4.27 19 2.51c-.007-.03 0-1.664 0-1.664 0-.574-.576-1.004-1.11-.79-.902.358-1.588 1.246-1.812 2.247C12.942 3.313 12.017 6.608 12 8.5V9H7.994c-1.186 0-2.661.615-3.312 1.552C2.546 11.27 0 13.317 0 19a1 1 0 0 0 2 0c0-2.799.672-4.753 2.001-5.834.053 1.521.714 3.117 1.257 4.426.224.54.437 1.054.581 1.492l-.209 1.511A2.994 2.994 0 0 0 8.596 24a2.98 2.98 0 0 0 2.959-2.539L11.78 20h1.219v1.005a3 3 0 0 0 6 0v-2.4l.384-1.812c.417-1.46.616-2.416.616-3.896v-2.016l2.234-.279a2.02 2.02 0 0 0 1.766-2c0-.794-.467-1.514-1.188-1.835zM10 18.423l-.42 2.733a.99.99 0 0 1-.983.843.98.98 0 0 1-.75-.34.98.98 0 0 1-.235-.79l.239-1.733a1 1 0 0 0-.031-.418c-.17-.58-.435-1.217-.714-1.892-.791-1.906-1.687-4.066-.63-5.232.342-.377.896-.594 1.518-.594H8v2c0 1.304.836 2.415 2 2.828zM11 14c-.551 0-1-.449-1-1v-2h2v2c0 .551-.449 1-1 1m8.752-5.102A2 2 0 0 0 18 10.882v2.016c0 1.25-.166 2.042-.555 3.412l-.423 1.98a1 1 0 0 0-.022.21v2.505a1 1 0 0 1-1.006.994.995.995 0 0 1-.994-.994V19a1 1 0 0 0-1-1h-2v-2.172A3 3 0 0 0 14 13V8.512c.007-.432.165-4.002 3.407-4.463.738 1.99 2.278 3.52 4.579 4.57z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-horse-saddle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHorseSaddle;
